export const formatDate = (isoString: string) => {
    if(!isoString) {
        return undefined;
    }
    return new Date(isoString).toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
    });
};

export const isValidJson = (str) => {
    try {
        const parsed = JSON.parse(str);
        return typeof parsed === 'object' && parsed !== null;
    } catch (e) {
        return false;
    }
}

export const toDatetimeLocal = (date: string | Date) => {
    if(!date) {
        return "2025-01-01T00:00";
    }
    const d = new Date(date)
    const offset = d.getTimezoneOffset()
    const localDate = new Date(d.getTime() - offset * 60 * 1000)
    return localDate.toISOString().slice(0, 16) // 'YYYY-MM-DDTHH:mm'
}

// Convert local datetime string back to ISO
export function toISO(value: string): string {
    return new Date(value).toISOString()
}

/**
 * Get the time status of an event
 * @param startTime
 * @param endTime
 * @param options (optional) - options object e.g. { label: "left", onboarding: true }
 */
export function getTimeStatusDate(startTime: Date, endTime: Date, options: object = {}) {
    const now = new Date();
    const diff = startTime.getTime() - now.getTime();
    const diffEnd = endTime.getTime() - now.getTime();

    if( options.onboarding ) {
        return "Event is available"
    }
    if (diffEnd <= 0 ) {
        return "Event is over!";
    }
    if (diff <= 0) {
        return "Event is Live!";
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);

    const label = options?.label || "";
    return `${days} days, ${hours} hours ${label}`;
}

export function getTimeStatus(startTime: string, endTime: string, options: object = {}) {
    return getTimeStatusDate(new Date(startTime), new Date(endTime), options);
}




export const scrollToBottom = (htmlDOMElement: string) => {
    const chatMessagesDiv = document.querySelector(htmlDOMElement);
    if (chatMessagesDiv) {
        chatMessagesDiv.scrollTop = chatMessagesDiv.scrollHeight;
    }
};

export const sleep = (ms: number): Promise<void> => {
    return new Promise(resolve => setTimeout(resolve, ms))
}
